import { Routes } from '@angular/router';
import { authenticatedRouteGuards, canActivateUser } from '@shared/guard/guard';
import { PageKey } from '@shared/services/page/models/page.key';

export const weeklyAllocationsRoute: Routes = [
  {
    path: 'weekly-allocations',
    loadComponent: () => import('./pages/allocation-board/allocation-board.component').then(m => m.AllocationBoardComponent),
    canActivate: [...authenticatedRouteGuards, canActivateUser],
    data: {
      title: 'Alocação',
      key: PageKey.WEEKLY_ALLOCATIONS
    }
  }
];
